<template>
  <div>
    <b-modal
      ref="modal"
      :title="'Lançar Estoque'"
      header-class="border-bottom-0"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">Compra #{{ purchase.number }}</div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <b-form-checkbox-group v-model="actions">
              <b-form-checkbox value="update_cost">
                Atualizar preço de custo
              </b-form-checkbox>
              <b-form-checkbox value="update_price">
                Atualizar preço de venda(Usa Markup)
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Lançar Estoque
        </button>
      </div>

      <error-handler :error="error" />
    </b-modal>
  </div>
</template>

<script>
import Filters from "@/mixins/Filters.js";

export default {
  data: function () {
    return {
      purchase: {},
      actions: [],
      error: null,
    };
  },

  methods: {
    open(purchase) {
      this.reset();

      this.purchase = purchase;
      this.$refs.modal.show();
    },

    reset() {
      this.purchase = null;
      this.actions = [];
      this.error = null;
    },

    async store() {
      this.error = null;

      let params = { id: this.purchase.id, actions: this.actions };

      this.$store.commit("showLoading");

      await this.$store
        .dispatch("purchase/postEmitPurchaseStockTransaction", params)
        .then((response) => {
          this.$refs.modal.hide();
          this.actions = [];

          this.$emit("store");
        })
        .catch((error) => {
          this.error = error;
        });

      this.$store.commit("hideLoading");
    },
  },
};
</script>

<style>
</style>
